
import { z } from "zod";

export const ParentRelationshipValues = ["REPLY", "REACTION", "COMMENT"] as const;
export const ParentRelationshipSchema = /* @__PURE__ */ z.enum(ParentRelationshipValues);
export const ParentRelationship: (typeof ParentRelationshipSchema)["enum"] = { "REPLY": "REPLY", "REACTION": "REACTION", "COMMENT": "COMMENT" };
export type ParentRelationship = (typeof ParentRelationshipValues)[number];
